import React from "react";
import styled from "styled-components";

export const Row = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

export const LeftImage = styled.img`
    height: 667px;
    width: 471px;
    margin-right: 20px;
    @media (max-width: 767px){
        height: 339px;
        width: auto;
        margin: 0;
    }
`;

export const RightImage = styled.img`
    height: 555px;
    width: 391px;
    margin-left: 20px;
    margin-top: 47px;
    @media (max-width: 767px){
        height: 339px;
        width: auto;
        margin: 20px 0 0 0;
    }
`;

export const Container = styled.div`
	margin: ${props => props.theme.spacing};
	max-width: ${props => props.theme.max};
    @media(max-width: 767px){
		margin:  ${(props) => props.theme.mobileSpacing};
	}
`;